// Generated by CoffeeScript 2.7.0
var OptionGroup, option_group_item_comp, option_group_item_mixin, other_option_group_item_comp;

option_group_item_mixin = {
  props: {
    option: {
      type: [Skylark.App.Model.SelectOption, Skylark.App.Model.SelectOptionProxy],
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    selectedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    iconClass: function() {
      if (this.multiple) {
        return 'slp-square-o';
      } else {
        return 'slp-circle-o';
      }
    },
    label: function() {
      return this.option.label;
    },
    checked: function() {
      return _.any(this.selectedOptions, (item) => {
        return item === this.option;
      });
    },
    optionDisabled: function() {
      return this.disabled || this.option._status === 'disabled';
    }
  }
};

other_option_group_item_comp = {
  name: 'other-option-group-item',
  mixins: [option_group_item_mixin],
  template: `<label class='option-group-item with-other' :disabled='option.disabled'>
  <input type='checkbox'
         hidden='true'
         :checked='checked'
         :disabled='option.disabled'
         @change.stop='checkedChangeFunc' />
  <i :class='iconClass'></i>
  <span class='item-label'>{{ label }}</span>
  <div class='item-input'>
    <input placeholder='请输入' type='text' />
  </div>
</label>`,
  methods: {
    checkedChangeFunc: function(event) {
      if (this.disabled) {
        return;
      }
      return this.$emit('checkedChange', this.option, event.target.checked);
    }
  }
};

option_group_item_comp = {
  name: 'option-group-item',
  mixins: [option_group_item_mixin],
  template: `<label class='option-group-item' :disabled='optionDisabled'>
  <input type='checkbox'
         hidden='true'
         :checked='checked'
         :disabled='optionDisabled'
         @click.stop='checkedChangeFunc' />
  <i :class='iconClass'></i>
  <span class='item-label'>{{ label }}</span>
</label>`,
  methods: {
    checkedChangeFunc: function(event) {
      if (this.checked) {
        event.preventDefault();
      }
      if (this.optionDisabled) {
        return;
      }
      return setTimeout(() => {
        return this.$emit('checkedChange', this.option, !this.checked);
      });
    }
  }
};

export default OptionGroup = Vue.extend({
  name: 'option-group',
  components: {
    'group-option-item': option_group_item_comp,
    'other-group-option-item': other_option_group_item_comp
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    otherOption: {
      type: Object
    },
    multiple: {
      type: Boolean,
      default: false
    },
    initialValue: {
      type: Array,
      default: function() {
        return [];
      }
    },
    canCancelSingleSelect: {
      type: Boolean,
      default: function() {
        return true;
      }
    }
  },
  template: `<div class='option-group'>
  <group-option-item v-for='option in options'
                     :key='option.uuid'
                     :option='option'
                     :multiple='multiple'
                     :selectedOptions='value'
                     @checkedChange='checkedChangeFunc' />
  <other-group-option-item v-if='otherOption'
                           :option='otherOption'
                           :multiple='multiple'
                           :selectedOptions='value'
                           @checkedChange='checkedChangeFunc' />
</div>`,
  data: function() {
    return {
      value: this.initialValue.slice(0)
    };
  },
  watch: {
    initialValue: function() {
      return this.reset();
    },
    value: {
      handler: function() {
        return this.$emit('valueChange', this.value);
      },
      immediate: true
    }
  },
  methods: {
    checkedChangeFunc: function(option, checked) {
      if (this.multiple) {
        return this.value = checked ? _.union(this.value, [option]) : _.without(this.value, option);
      } else {
        return this.value = checked || !this.canCancelSingleSelect ? [option] : [];
      }
    },
    reset: function() {
      return this.value = this.initialValue.slice(0);
    }
  }
});
